export default defineI18nConfig(() => ({
    legacy: false,
    locale: "es",
    fallbackLocale: "es",
}))
